import { render, staticRenderFns } from "./CampFaqs.vue?vue&type=template&id=93b67a1a&scoped=true&"
import script from "./CampFaqs.vue?vue&type=script&lang=js&"
export * from "./CampFaqs.vue?vue&type=script&lang=js&"
import style0 from "./CampFaqs.vue?vue&type=style&index=0&id=93b67a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b67a1a",
  null
  
)

export default component.exports